// GlobalActionSearchFilter.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';

interface Props {
  searchQuery: string;
  onSearch: (query: string) => void;
  selectedSdg: 'all' | number;
  onFilterChange: (value: 'all' | number) => void;
  itemCount: number;
  onCreate: () => void;
}

const GlobalActionSearchFilter: React.FC<Props> = ({
  searchQuery,
  onSearch,
  selectedSdg,
  onFilterChange,
  itemCount,
  onCreate
}) => {
  return (
    <div className='row align-items-end g-3 my-3'>
      <div className='col-md-6'>
        <div className='position-relative'>
          {!searchQuery && (
            <span className='position-absolute top-50 translate-middle-y' style={{ left: '20px' }}>
              <FontAwesomeIcon icon={faSearch} />
            </span>
          )}
          <input
            value={searchQuery}
            onChange={(e) => onSearch(e.target.value)}
            type='text'
            className='form-control ps-5'
            placeholder='Search actions'
          />
        </div>
      </div>

      <div className='col-md-2'>
        <select
          className='form-select'
          value={selectedSdg}
          onChange={(e) => {
            const val = e.target.value === 'all' ? 'all' : parseInt(e.target.value);
            onFilterChange(val);
          }}
        >
          <option value='all'>Filter by SDG: All</option>
          {[...Array(17)].map((_, i) => (
            <option key={i + 1} value={i + 1}>SDG {i + 1}</option>
          ))}
        </select>
      </div>

      <div className='col-md-4'>
        <button onClick={onCreate} className='btn btn-success w-60' style={{ position: 'relative', top: '-3px' }}>
          <FontAwesomeIcon icon={faPlus} className='me-2' /> Create Action
        </button>
      </div>
    </div>
  );
};

export default GlobalActionSearchFilter;
